import { defineStore } from 'pinia';
import { fetchStakes, fetchStakesCount } from '@/api/admin-be';
import type { ApiStakeItem, ApiStakesFilters } from '@/types/stakes';
import { catchError, toast } from '@/helpers/toast';

type StakesStoreState = ApiStakesFilters & {
  offset: number;
  count: number;
  size: number;
  records: ApiStakeItem[] | null;
  loading: boolean;
};

export const useStakesStore = defineStore('stakes', {
  state: () =>
    ({
      // translations
      records: null,

      // pagination
      offset: 0,
      count: 0,
      size: 15,

      // utility
      loading: false,

      // period
      fromDate: null,
      toDate: null,
      period: 'day',

      // filters
      skipEmpty: 'true',
      skipBanned: 'true',
      skipNonCurrency: 'true',
      detailSports: 'false',
      detailCurrencies: 'true',
      detailUsers: 'true',

      sportIds: null,
      userIds: null,
      currencies: null,
    }) as StakesStoreState,
  actions: {
    async fetchRecords() {
      const pagination = {
        offset: this.offset,
        size: this.size,
      };

      this.loading = true;

      this.records = await fetchStakes(pagination, {
        skipEmpty: this.skipEmpty,
        skipBanned: this.skipBanned,
        skipNonCurrency: this.skipNonCurrency,
        fromDate: this.fromDate,
        toDate: this.toDate,
        period: this.period,
        detailSports: this.detailSports,
        detailCurrencies: this.detailCurrencies,
        detailUsers: this.detailUsers,
        sportIds: this.sportIds,
        userIds: this.userIds,
        currencies: this.currencies,
      })
        .then((data) => {
          this.loading = false;
          return data;
        })
        .catch((error) => catchError('Ошибка загрузки ставок', error))
        .finally(() => {
          this.loading = false;
        });
    },
    async fetchRecordsCount() {
      this.count = await fetchStakesCount({
        skipEmpty: this.skipEmpty,
        skipBanned: this.skipBanned,
        skipNonCurrency: this.skipNonCurrency,
        fromDate: this.fromDate,
        toDate: this.toDate,
        period: this.period,
        detailSports: this.detailSports,
        detailCurrencies: this.detailCurrencies,
        detailUsers: this.detailUsers,
        sportIds: this.sportIds,
        userIds: this.userIds,
        currencies: this.currencies,
      }).catch((error) => catchError('Ошибка загрузки счетчика ставок', error));
    },
  },
});
